// ERPNext Project.status -> Anzeigetext (Liste und Detail teilen sich die Zuordnung, TQ #774).
export const PROJECT_STATUS_LABEL: Record<string, string> = {
  Open: 'Läuft',
  Completed: 'Abgeschlossen',
  Cancelled: 'Abgebrochen',
}

export const projectStatusLabel = (status?: string): string => (status ? PROJECT_STATUS_LABEL[status] ?? status : '')

/** Titelzeile des Projekt-Details: "<Projektname> — <Status>"; ohne Namen die PROJ-ID, ohne Status nur der Name. */
export const projectTitle = (projectName: string | undefined, id: string, status?: string): string => {
  const title = projectName?.trim() || id
  const label = projectStatusLabel(status)
  return label ? `${title} — ${label}` : title
}
